
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_6257_9)"}},[_c('path',{attrs:{"fill":"#798F8F","d":"M18 9.005a9 9 0 1 0-10.406 8.89v-6.289H5.309V9.005h2.285V7.022c0-2.256 1.343-3.502 3.4-3.502.984 0 2.014.176 2.014.176v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406v1.688h2.496l-.399 2.601h-2.097v6.29C14.71 17.22 18 13.495 18 9.004"}})]),_c('defs',[_c('clipPath',{staticClass:"i-clip0_6257_9"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    